import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/qualityRegulation';
const qualityRegulation: Array<RouteConfig> = [
    {
        path: 'basic-info/quality-regulation',
        name: 'qualityRegulation',
        redirect: { name: 'goodstype' },
        meta: {
            menuMatch: 'qualityRegulation',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'goodstype',
                name: 'goodstype',
                component: () => import(`@/${BASE_PATH}/Goodstype.vue`),
                meta: {
                    index: '6-1',
                },
            },
            {
                path: 'goodsbatch',
                name: 'goodsbatch',
                component: () => import(`@/${BASE_PATH}/Goodsbatch.vue`),
                meta: {
                    index: '6-2',
                },
            },
            {
                path: 'gpacompare',
                name: 'gpacompare',
                component: () => import(`@/${BASE_PATH}/Gpacompare.vue`),
                meta: {
                    index: '6-3',
                },
            },
            {
                path: 'gpacompare/detail',
                name: 'gpacompare-detail',
                component: () => import(`@/${BASE_PATH}/StandardDetail.vue`),
                meta: {
                    index: '6-3',
                    type:'GAP',
                    supPage:"gpacompare",
                    noBottom:true
                },
            },
            {
                path: 'numcompare',
                name: 'numcompare',
                component: () => import(`@/${BASE_PATH}/Numcompare.vue`),
                meta: {
                    index: '6-4',
                },
            },
            {
                path: 'numcompare/detail',
                name: 'numcompare-detail',
                component: () => import(`@/${BASE_PATH}/StandardDetail.vue`),
                meta: {
                    index: '6-4',
                    type:'数字化',
                    supPage:"numcompare",
                    noBottom:true
                },
            },
        ],
    },
];
export default qualityRegulation;